import N2StylesModal from '../components/N2StylesModal';

export default class Cart {
  constructor(params) {
    this.params = params;
    this.role = params.role || null;
  }

  edit() {
    if ($('.js-cart-submit').length) {
      this.bindConfirmSubmit();
    }

    if ($('.js-orders-input').length) {
      this.bindBlurToInput();
    }
  }

  update() {
    this.edit();
  }

  bindConfirmSubmit() {
    N2.bindGlobalHandler('click', '.js-cart-submit', (evt) => {
      evt.preventDefault();
      new N2StylesModal('.js-cart-submit-modal');
    });
  }

  bindBlurToInput() {
    N2.bindGlobalHandler('blur', '.js-orders-input', (evt) => {
      const target = $(evt.target);
      const id = target.data('id');
      const count = target.val();
      const previousCount = target.data('copies');

      // Cannot use N2.ManualForm because we need to return JSON response with right headers
      const url = `/cart/order_items/${id}`;


      if (parseInt(count, 10) !== parseInt(previousCount, 10)) {
        const fd = new FormData();
        fd.append('extra_copy_order_items[copies]', count);

        $.ajax({
          type: 'PATCH',
          url,
          data: fd,
          processData: false, // Do not process Form Data
          contentType: false, // Properly set contentType to application/json

          error() {
            toastr.options.positionClass = 'toast-bottom-center';
            toastr.info('Your change could not be made.');
            target.val(previousCount);
          },
        });
      }
    });
  }
}
